import { CarManagmentState } from 'providers/CarManagmentProvider';

//Action types
export const SET_TRIPS = 'SET_TRIPS';
export const SET_CARS = 'SET_CARS';
export const RESET_TRIPS_ERROR = 'RESET_TRIPS_ERROR';
export const SET_CARS_MANAGEMENT_MODAL = 'SET_CARS_MANAGEMENT_MODAL';
export const SET_CARS_STATE_LIST = 'SET_CARS_STATE_LIST';
export const SET_CAR_EVENTS = 'SET_CAR_EVENTS';
export const SET_OVERLAPS_CAR_ALOCATION = 'SET_OVERLAPS_CAR_ALOCATION';
export const SET_OVERLAPS_MAINTENANCE_ALOCATION =
  'SET_OVERLAPS_MAINTENANCE_ALOCATION';
export const SET_SPECIFIC_CAR_TRIPS = 'SET_SPECIFIC_CAR_TRIPS';

//Action ts type
export type CarManagment_ACTION_TYPE =
  | {
      type: typeof SET_TRIPS;
      payload: Partial<CarManagmentState>;
    }
  | {
      type: typeof SET_CARS;
      payload: Partial<CarManagmentState>;
    }
  | {
      type: typeof SET_CARS_MANAGEMENT_MODAL;
      payload: Partial<CarManagmentState>;
    }
  | {
      type: typeof SET_CARS_STATE_LIST;
      payload: Partial<CarManagmentState>;
    }
  | {
      type: typeof SET_CAR_EVENTS;
      payload: { carID: number; events: CarManagmentState['carsEvents'] };
    }
  | {
      type: typeof SET_OVERLAPS_CAR_ALOCATION;
      payload: Partial<CarManagmentState>;
    }
  | {
      type: typeof SET_OVERLAPS_MAINTENANCE_ALOCATION;
      payload: Partial<CarManagmentState>;
    }
  | {
      type: typeof SET_SPECIFIC_CAR_TRIPS;
      payload: Partial<CarManagmentState>;
    }
  | {
      type: typeof RESET_TRIPS_ERROR;
    };

// Reducer function
export const carManagmentReducer = (
  state: CarManagmentState,
  action: CarManagment_ACTION_TYPE
) => {
  switch (action.type) {
    case SET_TRIPS: {
      const { payload } = action;
      return {
        ...state,
        ...payload
      };
    }
    case SET_CARS: {
      const { payload } = action;
      return {
        ...state,
        ...payload
      };
    }
    case SET_CARS_MANAGEMENT_MODAL: {
      const { payload } = action;
      return {
        ...state,
        ...payload
      };
    }
    case SET_CARS_STATE_LIST: {
      const { payload } = action;
      return {
        ...state,
        ...payload
      };
    }
    case SET_CAR_EVENTS: {
      const { carID, events } = action.payload;
      return {
        ...state,
        maintenanceEventsByCar: {
          ...state.maintenanceEventsByCar,
          [carID]: events
        }
      };
    }
    case SET_OVERLAPS_CAR_ALOCATION: {
      const { payload } = action;
      return {
        ...state,
        ...payload
      };
    }
    case SET_OVERLAPS_MAINTENANCE_ALOCATION: {
      const { payload } = action;
      return {
        ...state,
        ...payload
      };
    }
    case RESET_TRIPS_ERROR: {
      return {
        ...state,
        tripsError: null
      };
    }
    case SET_SPECIFIC_CAR_TRIPS: {
      const { payload } = action;
      return {
        ...state,
        ...payload
      };
    }
    default:
      return state;
  }
};
